import MDN from "./images/mdn.png";
import W3Schools from "./images/w3schools.png";
import CssTricks from "./images/css-tricks.jpg";
import Medium from "./images/medium.png";
import Dev from "./images/dev.jpg";
import FCC from "./images/fcc.jpg";
import JsInfo from "./images/js-info.png";
import HackerNoon from "./images/hackernoon.jpeg";
import ReactImage from "./images/react-img.png";

export const dummyData = {
  HTML: [
    {
      image: MDN,
      name: "HTML: HyperText Markup Language",
      author: "MDN",
      rating: "4.7/5",
      link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
    },
    {
      image: W3Schools,
      name: "W3Schools is a perfect place to learn HTML.",
      author: "W3Schools",
      rating: "4.7/5",
      link: "https://www.w3schools.com/html/default.asp",
    },
    {
      image: CssTricks,
      name: "Snippets for HTML",
      author: "Chris Coyier",
      rating: "4.5/5",
      link: "https://css-tricks.com/snippets/html/",
    },
    {
      image: Medium,
      name: "Beginner’s HTML Cheat Sheet.",
      author: "Bradley Nice",
      rating: "4.3/5",
      link:
        "https://medium.com/level-up-web/beginners-html-cheat-sheet-f9b1e3ce88a6",
    },
    {
      image: Dev,
      name: "Stop using so many divs! An intro to semantic HTML",
      author: "Ken Bellows",
      rating: "4.3/5",
      link:
        "https://dev.to/kenbellows/stop-using-so-many-divs-an-intro-to-semantic-html-3i9i",
    },
  ],
  CSS: [
    {
      image: MDN,
      name: "CSS: Cascading Style Sheets",
      author: "MDN",
      rating: "4.7/5",
      link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    },
    {
      image: W3Schools,
      name: "W3Schools is a perfect place to learn .",
      author: "W3Schools",
      rating: "4.7/5",
      link: "https://www.w3schools.com/css/default.asp",
    },
    {
      image: CssTricks,
      name: "Snippets for CSS",
      author: "Chris Coyier",
      rating: "4.5/5",
      link: "https://css-tricks.com/snippets/css/",
    },
    {
      image: FCC,
      name: "CSS Naming Conventions that Will Save Your Hours",
      author: "Ohans Emmanuel",
      rating: "4.5/5",
      link:
        "https://medium.com/free-code-camp/css-naming-conventions-that-will-save-you-hours-of-debugging-35cea737d849",
    },
    {
      image: FCC,
      name: "The 100% correct way to do CSS breakpoints",
      author: "David Gilbertson",
      rating: "4.5/5",
      link:
        "https://medium.com/free-code-camp/the-100-correct-way-to-do-css-breakpoints-88d6a5ba1862",
    },
  ],
  Javascript: [
    {
      image: MDN,
      name: "JavaScript",
      author: "MDN",
      rating: "4.7/5",
      link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    },
    {
      image: JsInfo,
      name: "The Modern JavaScript Tutorial",
      author: "JavaScript Info",
      rating: "4.7/5",
      link: "https://javascript.info/",
    },
    {
      image: W3Schools,
      name: "JavaScript Tutorial",
      author: "W3schools",
      rating: "4.5/5",
      link: "https://www.w3schools.com/js/default.asp",
    },
    {
      image: FCC,
      name: "Is Vanilla JavaScript worth learning? Absolutely.",
      author: "David Kopal",
      rating: "4.7/5",
      link:
        "https://medium.com/free-code-camp/is-vanilla-javascript-worth-learning-absolutely-c2c67140ac34",
    },
    {
      image: HackerNoon,
      name: "Javascript Basics For React Beginners",
      author: "HackerNoon",
      rating: "4.5/5",
      link:
        "https://hackernoon.com/javascript-basics-for-react-beginners-1b1231c2",
    },
  ],
  React: [
    {
      image: ReactImage,
      name: "React Documentation",
      author: "reactjs.org",
      rating: "4.5/5",
      link: "https://reactjs.org/",
    },
    {
      image: Dev,
      name: "The React Cheatsheet for 2020",
      author: "Reed Barger",
      rating: "4.5/5",
      link:
        "https://dev.to/reedbarger/the-react-cheatsheet-for-2020-real-world-examples-4hgg",
    },
    {
      image: Medium,
      name: "Master these five concepts, then master React.",
      author: "Sacha Greif",
      rating: "4.5/5",
      link:
        "https://medium.com/free-code-camp/the-5-things-you-need-to-know-to-understand-react-a1dbd5d114a3",
    },
    {
      image: ReactImage,
      name: "How to learn React.js in 2020",
      author: "Robin Wieruch",
      rating: "4.5/5",
      link: "https://www.robinwieruch.de/learn-react-js",
    },
  ],
};
